const config = {
  apiClientId: 'T6kXrYaPUVd1MpheMQ9hbLmyjspAsF0cDk5Dzjj2', // pragma: allowlist secret
  apiClientSecret:
    's50mFdHEjxsrTy74c7FPVaNE8uc7lKcWvLejWvIg7pYAlqxfJb5D3VL3yTvLUUuNbzwTP56QNf1DzKhbbXZKsKAAh7iwwnDL1glzy19FE14Wa5f2zkb6bOD5kCT2ih8j' // pragma: allowlist secret
};

export default config;
